import { IRelatedProduct, RelationshipLabel } from "src/api/client/related-products.api.types";

export type IGroupedRelatedWikifolios = {
    base: IRelatedProduct | undefined;
} & Record<RelationshipLabel, IRelatedProduct[]>;

export function groupRelatedWikifoliosByLabel(products: IRelatedProduct[]): IGroupedRelatedWikifolios {
    const base = products.find(p => p.isBase);

    const grouped: IGroupedRelatedWikifolios = {
        base,
        ParadiseWikifolioLumpSum: [],
        ParadiseWikifolioTargetDate: [],
    };

    for (const product of products) {
        if (product.relationshipLabel !== null) {
            grouped[product.relationshipLabel].push(product);
        }
    }

    return grouped;
}
